/* ============================================================================
   Saved Fellas outside the home page (2026-10-22; ZZ: Compare out, Saved Fellas stays).
   The home page owns Saved Fellas (assets/bz-v4-commerce.js): it keeps the list in localStorage under
   'bigzs-storefront-v4:preferences' (saved: catalog ids) and shows it in a drawer. Every other page
   only adds to that list and shows how many are on it, with the same key and shape, so a fella saved
   here is in the drawer and the counts agree:
     - the heart on a product page, for animals and enclosures in the home catalog
       (snippets/bz-fix-layer prints #bz-save-ctx with the catalog id and name),
     - the Saved pill in the floating helpers (snippets/bz-floaters), shown once anyone is saved,
       which opens /#saved-fellas: the home page drawer.
   Loaded from layout/theme.liquid. Styles: snippets/bz-fix-layer.
   ========================================================================== */
(function () {
  'use strict';
  if (window.bzSaved) return;
  window.bzSaved = true;

  var KEY = 'bigzs-storefront-v4:preferences';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';

  function read() {
    try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); return s && typeof s === 'object' ? s : {}; } catch (e) { return {}; }
  }
  function saved() {
    var s = read();
    return Array.isArray(s.saved) ? s.saved.map(String) : [];
  }
  // Read, change only the saved list, write back: the home page keeps its other preferences in the same object.
  function writeSaved(list) {
    var s = read();
    s.saved = list;
    try { localStorage.setItem(KEY, JSON.stringify(s)); return true; } catch (e) { return false; }
  }

  /* ---------- the Saved pill ---------- */
  var pill = document.querySelector('[data-bz-saved-floater]');
  var pillCount = pill && pill.querySelector('[data-bz-saved-count]');
  function paintPill() {
    if (!pill) return;
    var n = saved().length;
    if (pillCount) pillCount.textContent = n > 99 ? '99+' : String(n);
    pill.setAttribute('aria-label', 'Open Saved Fellas, ' + n + ' saved');
    pill.hidden = n === 0;
  }

  /* ---------- the product page heart ---------- */
  var ctxEl = document.getElementById('bz-save-ctx');
  var ctx = null;
  try { ctx = ctxEl ? JSON.parse(ctxEl.textContent) : null; } catch (e) { ctx = null; }
  var heart = null, live = null;
  function paintHeart() {
    if (!heart) return;
    var on = saved().indexOf(ctx.id) !== -1;
    heart.setAttribute('aria-pressed', on ? 'true' : 'false');
    heart.setAttribute('aria-label', (on ? 'Remove ' + ctx.name + ' from' : 'Save ' + ctx.name + ' to') + ' Saved Fellas');
  }
  if (ctx && ctx.id) {
    var media = document.querySelector('.bz-product-media__main');
    if (media) {
      heart = document.createElement('button');
      heart.type = 'button';
      heart.className = 'bz-save-heart';
      heart.innerHTML = HEART;
      media.appendChild(heart);
      live = document.createElement('span');
      live.className = 'bz-sr-live';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      media.appendChild(live);
      heart.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = saved(), i = list.indexOf(ctx.id), on = i === -1;
        if (on) list.push(ctx.id); else list.splice(i, 1);
        if (!writeSaved(list)) { if (live) live.textContent = 'Saved Fellas needs browser storage, which is off here.'; return; }
        paintHeart();
        paintPill();
        if (live) live.textContent = on ? ctx.name + ' saved to Saved Fellas.' : 'Removed from Saved Fellas.';
      });
      paintHeart();
    }
  }

  paintPill();
  // Another tab (or the home page) changed the list.
  window.addEventListener('storage', function (e) { if (e.key === KEY) { paintPill(); paintHeart(); } });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { paintPill(); paintHeart(); } });
})();